const SITE_ORIGIN = 'https://integra3646.com';
const SITE_NAME = 'INTEGRA 3646';
const SITE_ALTERNATE_NAME = 'Team 3646 Bahçeşehir INTEGRA';
const MAIN_SEO_TITLE = 'INTEGRA 3646 | FRC Team from Istanbul';
const HOMEPAGE_PREVIEW_TEXT = 'Building sustainable FIRST and STEM infrastructure through robotics, mentorship, public resources, curriculum, and community partnerships.';
const PRIMARY_SEO_DESCRIPTION = 'INTEGRA 3646 is an Istanbul-based FIRST Robotics Competition team building sustainable STEM and FIRST infrastructure through robotics, mentorship, public resources, curriculum, and community partnerships.';
const DEFAULT_OG_IMAGE_PATH = '/integra-new-logo.svg';
const DEFAULT_OG_IMAGE = `${SITE_ORIGIN}${DEFAULT_OG_IMAGE_PATH}`;
const DEFAULT_OG_IMAGE_ALT = 'INTEGRA 3646 team logo';
const THEME_COLOR = '#FEDD00';
const ROBOTS_CONTENT = 'index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1';
const TWITTER_HANDLE = '@FRC_Integra3646';

const PRIMARY_NAVIGATION = [
  { label: 'Home', path: '/' },
  { label: 'About', path: '/about' },
  { label: 'Awards', path: '/awards' },
  { label: 'Projects', path: '/projects' },
  { label: 'Sponsors', path: '/sponsors' },
  { label: 'IntegrAI', path: '/integrai' },
];

const SOCIAL_LINKS = [
  {
    platform: 'Instagram',
    href: 'https://www.instagram.com/integra_3646',
    label: 'Follow INTEGRA 3646 on Instagram',
  },
  {
    platform: 'X',
    href: 'https://x.com/FRC_Integra3646',
    label: 'Follow INTEGRA 3646 on X',
  },
  {
    platform: 'YouTube',
    href: 'https://www.youtube.com/@frc3646',
    label: 'Follow INTEGRA 3646 on YouTube',
  },
  {
    platform: 'TikTok',
    href: 'https://www.tiktok.com/@integra.3646',
    label: 'Follow INTEGRA 3646 on TikTok',
  },
  {
    platform: 'LinkedIn',
    href: 'https://www.linkedin.com/in/bahcesehir-integra-a4756a301/',
    label: 'Connect with INTEGRA 3646 on LinkedIn',
  },
];

const AI_CRAWLERS = [
  'GPTBot',
  'OAI-SearchBot',
  'ChatGPT-User',
  'ClaudeBot',
  'Claude-SearchBot',
  'Claude-User',
  'Google-Extended',
  'PerplexityBot',
];

const TOP_LEVEL_PAGES = [
  {
    path: '/',
    title: MAIN_SEO_TITLE,
    description: HOMEPAGE_PREVIEW_TEXT,
    seoDescription: PRIMARY_SEO_DESCRIPTION,
    sections: [
      'Hero',
      'Awards highlights',
      'Featured video',
      'Projects showcase',
      'Sponsors showcase',
    ],
  },
  {
    path: '/about',
    title: 'About INTEGRA 3646',
    description: 'About page covering team history, mission, FIRST overview, and FIRST Robotics Competition context.',
    sections: [
      'About INTEGRA 3646',
      'Our Journey',
      'Our Mission',
      'What is FIRST?',
      'FIRST Robotics Competition (FRC)',
    ],
  },
  {
    path: '/awards',
    title: 'Awards | INTEGRA 3646',
    description: 'Awards archive for INTEGRA 3646 with year-by-year recognition and competition results.',
    sections: [
      'Our Awards',
      'Year-by-year awards timeline',
    ],
  },
  {
    path: '/projects',
    title: 'Projects | INTEGRA 3646',
    description: 'Projects index page listing community, STEM, outreach, education, and innovation initiatives by INTEGRA 3646.',
    sections: [
      'Projects overview',
      'Projects grid',
    ],
  },
  {
    path: '/sponsors',
    title: 'Sponsors | INTEGRA 3646',
    description: 'Sponsors and partners page with partner tiers, logo grids, and a compact sponsor marquee on the homepage.',
    sections: [
      'Our Valued Partners',
      'Partner tiers',
      'Logo grids',
    ],
  },
  {
    path: '/integrai',
    title: 'IntegrAI | INTEGRA 3646',
    description: 'IntegrAI page for asking source-backed questions about FIRST Robotics Competition rules, live event data, and Team 3646 history.',
    sections: [
      'IntegrAI hero',
      'What It Can Do',
      'Ask IntegrAI',
      'Answer and source list',
    ],
  },
  {
    path: '/privacy',
    title: 'Cookie & Analytics Notice | INTEGRA 3646',
    description: 'Privacy notice covering optional analytics consent, IntegrAI analytics metadata, and cookie choices for integra3646.com.',
    sections: [
      'Cookie & Analytics Notice',
      'Consent controls',
      'What we measure',
      'What we do not send',
    ],
  },
];

function toAbsoluteUrl(routePath) {
  return routePath === '/' ? `${SITE_ORIGIN}/` : `${SITE_ORIGIN}${routePath}`;
}

function buildSiteStructure(projectPages = []) {
  return {
    siteName: SITE_NAME,
    alternateName: SITE_ALTERNATE_NAME,
    siteOrigin: SITE_ORIGIN,
    siteSummary: PRIMARY_SEO_DESCRIPTION,
    homepagePreviewText: HOMEPAGE_PREVIEW_TEXT,
    primarySeoTitle: MAIN_SEO_TITLE,
    primarySeoDescription: PRIMARY_SEO_DESCRIPTION,
    defaultOgImage: DEFAULT_OG_IMAGE,
    defaultOgImagePath: DEFAULT_OG_IMAGE_PATH,
    defaultOgImageAlt: DEFAULT_OG_IMAGE_ALT,
    primaryNavigation: PRIMARY_NAVIGATION,
    socialLinks: SOCIAL_LINKS,
    aiCrawlers: AI_CRAWLERS,
    topLevelPages: TOP_LEVEL_PAGES,
    projectPages,
  };
}

const siteMeta = {
  AI_CRAWLERS,
  DEFAULT_OG_IMAGE,
  DEFAULT_OG_IMAGE_ALT,
  DEFAULT_OG_IMAGE_PATH,
  HOMEPAGE_PREVIEW_TEXT,
  MAIN_SEO_TITLE,
  PRIMARY_NAVIGATION,
  PRIMARY_SEO_DESCRIPTION,
  ROBOTS_CONTENT,
  SITE_ALTERNATE_NAME,
  SITE_NAME,
  SITE_ORIGIN,
  SOCIAL_LINKS,
  THEME_COLOR,
  TOP_LEVEL_PAGES,
  TWITTER_HANDLE,
  buildSiteStructure,
  toAbsoluteUrl,
};

export {
  AI_CRAWLERS,
  DEFAULT_OG_IMAGE,
  DEFAULT_OG_IMAGE_ALT,
  DEFAULT_OG_IMAGE_PATH,
  HOMEPAGE_PREVIEW_TEXT,
  MAIN_SEO_TITLE,
  PRIMARY_NAVIGATION,
  PRIMARY_SEO_DESCRIPTION,
  ROBOTS_CONTENT,
  SITE_ALTERNATE_NAME,
  SITE_NAME,
  SITE_ORIGIN,
  SOCIAL_LINKS,
  THEME_COLOR,
  TOP_LEVEL_PAGES,
  TWITTER_HANDLE,
  buildSiteStructure,
  toAbsoluteUrl,
};

export default siteMeta;
